<template>
  <div :class="['station-tab-button', {'active': active}]" @click.prevent="tabClicked">
    <i :class="['far', 'fa-fw', icon]"></i>
    <div>{{name}}</div>
    <span class="badge" v-if="badge > 0">{{badge}}</span>
  </div>
</template>

<script>
export default {
  name: 'StationTabButton',
  props: {
    icon: String,
    name: String,
    badge: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: false
    }
  },
  inject: {
    stationTabbedPage: {
      default() {
        return { }
      }
    }
  },
  mounted() {
    this.registerTabItem()
  },
  beforeDestroy() {
    
  },
  destroyed() {
    this.unregisterTabItem()
  },
  methods: {
    registerTabItem() {
      this.stationTabbedPage.registerTabItem && this.stationTabbedPage.registerTabItem(this)
    },
    unregisterTabItem() {
      this.stationTabbedPage.unregisterTabItem && this.stationTabbedPage.unregisterTabItem(this)
    },
    tabClicked() {
      this.stationTabbedPage.showTab(this)
    }
  }
}
</script>